const EmbeddedComponents = require('@/vue/EmbeddedComponents');
const PaymentMethodRef = require('@/lib/PaymentMethods/PaymentMethodRef');
const { PAYMENT_METHOD_CHANGED } = require('@/lib/Events/EventNames');

/**
 * @param $filter
 * @param {PaymentMethodService} paymentMethodService
 * @param $scope
 */
function DojoWebPosPaymentCtrl(
    $filter,
    paymentMethodService,
    $scope,
) {
    const thisPaymentMethodRef = PaymentMethodRef.CARD_DOJO_CHIP_AND_PIN;
    $scope.$on('$destroy', () => {
        window.rootVueStore.commit('removeActiveEmbeddedComponent', EmbeddedComponents.DOJO_WEBPOS_PAYMENT_METHOD_COMPONENT);
    });
    $scope.$on(PAYMENT_METHOD_CHANGED, function (event, newPaymentMethod) {
        const newPaymentMethodRef = newPaymentMethod?.ref;
        if (newPaymentMethodRef === thisPaymentMethodRef) {
            window.rootVueStore.commit('addActiveEmbeddedComponent', { name: EmbeddedComponents.DOJO_WEBPOS_PAYMENT_METHOD_COMPONENT });
        } else {
            window.rootVueStore.commit('removeActiveEmbeddedComponent', EmbeddedComponents.DOJO_WEBPOS_PAYMENT_METHOD_COMPONENT);
        }
    });
}
module.exports = DojoWebPosPaymentCtrl;
